import img_loading from "@/Globals/_images/loading.gif";

export function LoadingIcon(): JSX.Element {
    return <img src={img_loading} alt="loading" />;
}
